import { render, staticRenderFns } from "./VehicleDetailModal.vue?vue&type=template&id=4bcac09c&scoped=true&lang=pug"
import script from "./VehicleDetailModal.vue?vue&type=script&lang=js"
export * from "./VehicleDetailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcac09c",
  null
  
)

export default component.exports